__turbopack_context__.v({
  "home_link": "R7DPYG_home_link",
  "live_tv_icon": "R7DPYG_live_tv_icon",
  "my_station_icon": "R7DPYG_my_station_icon",
  "push": "R7DPYG_push",
  "shows_icon": "R7DPYG_shows_icon",
  "svp_home_link": "R7DPYG_svp_home_link",
  "svp_station_logo": "R7DPYG_svp_station_logo",
  "utility_nav": "R7DPYG_utility_nav",
  "utility_nav__scrolled": "R7DPYG_utility_nav__scrolled",
  "utility_nav_link_active": "R7DPYG_utility_nav_link_active",
  "utility_nav_links": "R7DPYG_utility_nav_links",
});
